import React from 'react';
import weirdoimg from './assets/image.png';

function ProjectTwo() {
  return (
    <div>
      <h2>bitcoin weirdos</h2>
      <div style={{ 
        display: 'flex', 
        gap: '2rem', 
        alignItems: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'wrap'
      }}>
        <div id="imageproject" style={{ 
          flex: '0 0 420px',
          maxWidth: '100%'
        }}>
          <p><img src={weirdoimg} alt="Weirdo" style={{ 
            width: '100%', 
            maxWidth: '100%', 
            display: 'block',
            height: 'auto'
          }} /></p>
        </div>
        <div id="description" style={{ 
          flex: '1',
          minWidth: '280px'
        }}>
          <p>bitcoin weirdos is an oil on bitcoin collection paying tribute to us weirdos, bitcoin and ordinals enthusiasts</p>      
          <p>this 10k collection was asked and voted by the community following the artistic evolution of the weirdos </p>
          <p>in memory of everything we went through</p>
          <p>mint started the 15th of april 2025 and minted out the 23rd of may 2025, price was free </p>
        </div>
      </div>
    </div>
  );
}

export default ProjectTwo; 